import React from "react";
import {Image, Link, Typography} from "bonprix-design-system";
import {contentElement} from "../../helper/content-element/content-elements";
import ModelContainer from "@core/scripts/components/model-container.js";


const imageUrl = 'https:' + ModelContainer.get('imageContext').imageBaseUrl + 'bonprixbilder/allgemein/flags/bpde/circularID.jpg';

export default function SustainabilityCircularityID({href}) {

    const text = contentElement('pdp__sustainability_circularityId_text');
    const parts = text.split(/<<(.*?)>>/);

    const createLink = (content) => {
        return <Link href={href} target="_blank" aria-label={contentElement('pdp__sustainability_circularityId_linkLabel')}>
            {content}
        </Link>
    }

    return (
        <div className='mb-5 mr-3'>
            {createLink(<Image alt={contentElement('pdp__sustainability_circularityId_imgAlt')} defaultSrc={imageUrl} srcSet='{}' />)}

            <Typography variant={"bonprix-h5"}>{contentElement('pdp__sustainability_circularityId_title')}</Typography>
            <Typography variant={"body2"} color='on-bg-low'>
                {parts[0]}
                {createLink(parts[1])}
                {parts[2]}
            </Typography>
        </div>
    );
}